import React, { useEffect, useState } from "react";
import { auth } from "../firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import LoginRegister from "./loginRegister";
import PostEditor from "./PostEdiotr";
import CategoriesManager from "./CategoriesManager";
import PublishPanel from "./PublishPanel";
import PostList from "./PostList";
import PhotoUpload from "./EventEditor";
const Dashboard = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return unsubscribe;
  }, []);

  if (!user) {
    return <LoginRegister onLogin={() => {}} />;
  }

  return (
    <div className="dashboard text-white bg-dark min-vh-100 p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Pulse of the Underground – Dashboard</h1>
        <button className="btn btn-danger" onClick={() => signOut(auth)}>
          Logout
        </button>
      </div>
      <PostEditor/>
      <CategoriesManager/>
      <PublishPanel />
      <PostList />
            <PhotoUpload />


    </div>
  );
};

export default Dashboard;
